import { Injectable } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class PaymentScheduleCommand extends BaseProductCommand {
  readonly type = 'paymentSchedule';
  readonly title = 'График платежей';
  readonly icon = 'scheduler';
  readonly productType = ProductTypes.CREDIT;
  readonly isInfoAction = true;
  readonly settingsNames = ['OTHER/PAYMENT_SCHEDULE'];

  get order(): number {
    return this.getContextualOrder({
      [ProductTypes.CREDIT]: 20         // Кредит: График платежей (2-й в списке "прочее")
    }, 999);
  }

  constructor(
    private navigationService: NavigationService,
    commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push(`product/${context.data.id}/payment-schedule`);
  }
}

